$(document).ready(function () {
  revealContent();
});

function revealContent() {
  $("body").removeClass("is-hidden");
}